<template>
  <div class="panel-body">
    <template>
      <v-card width="1000px">
      <v-data-table
        a
        :headers="headers"
        :items="rules"
        item-key="userSelectedRuleId"
        class="elevation-1"
        :rows-per-page="rowsPerPage"
      >
      <template slot="item" slot-scope="props">
        <tr v-on:click="$emit('open-rule', props.item)">
          <td class="text-xs-center" width="500px">{{ props.item.userSelectedRuleId }}</td>
          <td class="text-xs-center" width="500px">{{ ruleTypes[props.item.ruleTypeId] }}</td>
          <td class="text-xs-center" width="500px">{{ ruleActionTypes[props.item.ruleActionTypeId] }}</td>
          <td class="text-xs-center" width="500px">{{ props.item.amount }}</td>
          <td class="text-xs-center" width="500px">{{ formatDate(props.item.startDate) }}</td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
    </v-card>
    </template>
  </div>

</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    jarId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loadingHistory: false,
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    errors: [],
    headers: [
      { text: 'Id', align: 'left', sortable: false, value: 'userSelectedRuleId' },
      { text: 'Rule Type', value: 'ruleTypeId' },
      { text: 'Rule Action Type', value: 'ruleActionTypeId' },
      { text: 'Amount', value: 'amount' },
      { text: 'Start Date', value: 'createdDate' }
    ],
    rules: [],
    ruleActionTypes: {
      1: 'Round up',
      2: 'Percentage',
      3: 'Set amount'
    },
    ruleTypes: {
      1: 'Merchant',
      2: 'Deposit',
      3: 'Budget',
      4: 'Monthly',
      5: 'System - Deposit source',
      6: 'System - Merchant frequency',
      7: 'System - Merchant spend',
      8: 'System - Categorization',
      9: 'Manual',
      10: 'Daily',
      11: 'Weekly',
      12: 'Fitness',
      13: 'Sports',
      14: 'Challenge',
      15: 'Unused',
      16: 'Biweekly'
    }
  }),
  created () {
    this.loadRules()
  },
  mounted () {
    this.loadRules()
  },
  watch: {
    jarId: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadRules()
      }
    }
  },

  methods: {
    async loadRules () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_RULES}/rules?jarId=${this.jarId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.rules = [] } else { this.rules = getResponse.data }
    },
    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
